module["exports"] = [
  "Південний",
  "Північний",
  "Східний",
  "Західний"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/city_prefix.js
// module id = 1290
// module chunks = 0